/**
 * Created by Some Cool Dude on 07/31/2018.
 */
/**
 * @ngDoc: accumsDeserialzer
 * @description: 'Creates Lob object from plan progress payloads.'
 */

module.exports = function (btsUi) {
    btsUi.factory('ViewRulesEngineFactory', ['$cookies', function ($cookies) {
        //var eventsList = {};

        function resolve(path, obj) {
            //console.log('Resolve', path, obj);
            var pathArray = path.split('.') || [path];
            return pathArray.reduce(function (prev, curr) {
                return prev ? prev[curr] : null;
            }, obj);
        }

        var defaultQualifiersMethod = {
            execute: function (dataSource, qualifiers, qualifiersMap) {
                var check = false;
                var keys = Object.keys(qualifiers);
                if (keys.length > 0) {
                    for (var i = 0; i < keys.length; i++) {
                        if (qualifiersMap[keys[i]]) {
                            //console.log(qualifiersMap[keys[i]]);
                            var data = resolve(qualifiersMap[keys[i]].dataSource, dataSource);
                            if (['boolean', 'string', 'number'].indexOf(typeof(data)) > -1) {
                                switch (qualifiersMap[keys[i]].checkMethod) {
                                    case 'equal':
                                        //console.log('Checking Equal:', qualifiers[keys[i]], data);
                                        if (qualifiers[keys[i]] == data || qualifiers[keys[i]] == (data.toString && data.toString())) {
                                            check = true;
                                        }
                                        break;
                                    case 'greaterThanZero':
                                        if (data > 0) {
                                            check = true;
                                        }
                                        break;
                                    case 'otherPlanCookie':
                                        check = $cookies.get("mbrViewSiteByPlanSelection") === 'true';
                                        break;
                                    case 'equalBAOrSBA':
                                        var stringData = data.toString();
                                        if (qualifiers[keys[i]] && (stringData == "BA" || stringData == "SBA" || stringData == "BACANCELLED" || stringData == "SBACANCELLED")) {
                                            check = false;
                                        }
                                        break;

                                }
                            }
                        }
                    }
                } else {
                    check = true;
                }
                return check;
            }
        };

        var defaultQualifiersMap = {
            "availablePrePassword": {"dataSource": 'loggedIn', "checkMethod": "equal"},
            "availablePostPassword": {"dataSource": 'loggedIn', "checkMethod": "greaterThanZero"},
            "availableForEmployer": {"dataSource": 'basicInfo.role', "checkMethod": "equalBAOrSBA"},
            "medicalCoverage": {"dataSource": 'accountBenefits.medical', "checkMethod": "equal"},
            "pharmacyCoverage": {"dataSource": 'accountBenefits.drug', "checkMethod": "equal"},
            "dentalCoverage": {"dataSource": 'accountBenefits.dental', "checkMethod": "equal"},
            "drugCoverage": {"dataSource": 'accountBenefits.drug', "checkMethod": "equal"},
            "visionCoverage": {"dataSource": 'accountBenefits.vision', "checkMethod": "equal"},
            "directPayCoverage": {"dataSource": 'directPayIndicator', "checkMethod": "equal"},
            "fsa": {"dataSource": 'fsaExistsIndicator', "checkMethod": "equal"},
            "hra": {"dataSource": 'hcraIndicator', "checkMethod": "equal"},
            "hsa": {"dataSource": 'hsaExistsIndicator', "checkMethod": "equal"},
            "spendingAccounts": {"dataSource": 'spendingAccountExistsIndicator', "checkMethod": "equal"},
            "relationship": {"dataSource": 'relationship', "checkMethod": "equal"},
            "otherPlans": {"dataSource": "loggedIn", "checkMethod": "otherPlanCookie"}
        };

        function ViewRulesEngine(dataSource, qualifiers, qualifiersMap, qualifiersMethod) {
            this.dataSource = dataSource || {};
            this.qualifiers = qualifiers || {};
            this.qualifiersMap = qualifiersMap || defaultQualifiersMap;
            this.qualify = qualifiersMethod || defaultQualifiersMethod;
            this.setDataSource = function (dataSource) {
                this.dataSource = dataSource;
                return this.dataSource;
            };
            this.setQualifiers = function (qualifiers) {
                this.qualifiers = qualifiers;
                return this.qualifiers;

            };
            this.setQualifiersMap = function (map) {
                this.qualifiersMap = map;
                return this.qualifiersMap;

            };
            this.getQualifiersMap = function () {
                return this.qualifiersMap;
            };
            this.setQualifyMethod = function (newMethod) {
                if (typeof newMethod === 'function') {
                    this.qualify = newMethod;
                    return this.qualify;
                }
                throw "MemberRulesEngine.changeQualifyMethod : method argument is not a function";
            };
            this.getQualifiersMethod = function () {
                return this.qualify;
            };
            this.execute = function () {
                var bool = this.qualify.execute(this.dataSource, this.qualifiers, this.qualifiersMap);
                //console.log(bool);
                return bool;
            };

            //Conceptual Event Manager
            this.registerEvent = function (name, fn) {
                if (!this.eventList[name]) {
                    this.eventsList[name] = {fn: fn, listener: []};
                    return this.eventsList[name];
                }
                console.log('Event ' + name + ' already exists!');
                return this.eventsList[name];
            };
            this.listenToEvent = function (eventName, listener) {
                if (this.eventsList[name]) {
                    this.eventsList[name].listener = listener;
                    return this.eventsList[name];
                }
                return 'Event Doesn\'t exist';
            };
        }

        return function (dataSource, qualifiers) {
            return new ViewRulesEngine(dataSource, qualifiers);
        };
    }]);
};
